<div class="container-fluid justify-content-center h-100 d-flex flex-column">
  <div class="row justify-content-center px-4">
    <mat-card class="login-card col-12 col-md-8 col-lg-6 col-xl-5 p-5">
      <mat-card-content class="d-flex flex-column">
        <h1 class="mb-2">{{'general.app_name' | translate}}​</h1>

        <!-- Loading State -->
        @if (isLoading()) {
        <div class="loading-container text-center py-4">
          <mat-spinner diameter="40" class="mb-3"></mat-spinner>
          <p class="mb-0">{{'auth.redirecting_to_provider' | translate}}</p>
        </div>
        }

        <!-- Error State -->
        @if (errorMessage() && !isLoading()) {
        <div class="error-container py-4">
          <mat-error class="mb-3">
            <mat-icon>error</mat-icon>
            {{ errorMessage() }}
          </mat-error>
          <button mat-raised-button color="primary" (click)="retryLogin()" class="w-100">
            <mat-icon>refresh</mat-icon>
            {{'auth.retry_login' | translate}}
          </button>
        </div>
        }

        <!-- Multiple Providers Selection -->
        @if ((providers()).length > 1 && !isLoading() && !errorMessage()) {
        <ng-container>
          <hr class="my-4" />
          <div class="provider-button-container">
            @for (provider of providers(); track provider.label) {
            <button mat-raised-button class="align-self-stretch mb-4" color="primary" (click)="loginWithOAuth2(provider.url)">
              <mat-icon>arrow_right</mat-icon>
              {{'pages.login.connect_via' | translate: {provider: provider.label} }}
            </button>
            }
          </div>
        </ng-container>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>